import Blob from '../../../../assets/blob_mania.mp4';
import DnD from '../../../../assets/DnD.mp4';
import sidekick from '../../../../assets/sidekick.mp4';
import BlobMobile from '../../../../assets/blob.png'
import SidekickMobile from '../../../../assets/sidekick_mobile.png'
import DndMobile from '../../../../assets/dnd_mobile.png'

export const completedPieces = [
    {
        title: 'Sidekick',
        media: sidekick,
        mobileMedia: SidekickMobile,
        github: 'https://github.com/AlinaB108/pos-system-5000',
        deployed: 'https://sidekick-pos-a138f104c04c.herokuapp.com/pos',
        summary: 'A restaurant POS application that utilizes a full MERN stack to drive efficient ordering and sales. To test it out, use the fake employee login ID: 1002',
        technology: [
            { source: 'https://img.shields.io/badge/JavaScript-F7DF1E.svg?style=for-the-badge&logo=JavaScript&logoColor=black',
            alt: 'JavaScript'
            },
            { source: 'https://img.shields.io/badge/Node.js-339933.svg?style=for-the-badge&logo=nodedotjs&logoColor=white',
            alt: 'Node.Js'
            },
            { source: 'https://img.shields.io/badge/Express-000000.svg?style=for-the-badge&logo=Express&logoColor=white',
            alt: 'Express'
            },
            { source: 'https://img.shields.io/badge/React-61DAFB.svg?style=for-the-badge&logo=React&logoColor=black',
            alt: 'React'
            },
            { source: 'https://img.shields.io/badge/MongoDB-47A248.svg?style=for-the-badge&logo=MongoDB&logoColor=white',
            alt: 'MongoDB'
            },
            { source: 'https://img.shields.io/badge/Mongoose-880000.svg?style=for-the-badge&logo=Mongoose&logoColor=white',
            alt: 'Mongoose'
            },
            { source: 'https://img.shields.io/badge/Apollo%20GraphQL-311C87.svg?style=for-the-badge&logo=Apollo-GraphQL&logoColor=white',
            alt: 'GraphQL'
            },
            { source: 'https://img.shields.io/badge/JSON%20Web%20Tokens-000000.svg?style=for-the-badge&logo=JSON-Web-Tokens&logoColor=white',
            alt: 'JSON Web Tokens'
            },
            { source: 'https://img.shields.io/badge/React%20Router-CA4245.svg?style=for-the-badge&logo=React-Router&logoColor=white',
            alt: 'React Router'
            },
            { source: 'https://img.shields.io/badge/Material--UI-0081CB?style=for-the-badge&logo=mui&logoColor=white',
            alt: 'Material UI'
            }
        ]
    },
    {
        title: 'Blob Mania',
        media: Blob,
        mobileMedia: BlobMobile,
        github: 'https://github.com/Savannah-Shifflet/blob-mania',
        deployed: 'https://blob-mania-322037286e7b.herokuapp.com/',
        summary: 'A full-stack web-based multiplayer 2D shooter game with a retro aesthetic. The application is structured using the MVC paradigm and utilizes Node.js, sockets, and MySQL.',
        technology: [
            { source: 'https://img.shields.io/badge/JavaScript-F7DF1E.svg?style=for-the-badge&logo=JavaScript&logoColor=black',
            alt: 'JavaScript'
            },
            { source: 'https://img.shields.io/badge/Node.js-339933.svg?style=for-the-badge&logo=nodedotjs&logoColor=white',
            alt: 'Node.Js'
            },
            { source: 'https://img.shields.io/badge/Express-000000.svg?style=for-the-badge&logo=Express&logoColor=white',
            alt: 'Express'
            },
            { source: 'https://img.shields.io/badge/HTML5-E34F26.svg?style=for-the-badge&logo=HTML5&logoColor=white',
            alt: 'HTML'
            },
            { source: 'https://img.shields.io/badge/Bootstrap-7952B3.svg?style=for-the-badge&logo=Bootstrap&logoColor=white',
            alt: 'Bootstrap'
            },
            { source: 'https://img.shields.io/badge/Handlebars.js-000000.svg?style=for-the-badge&logo=handlebarsdotjs&logoColor=white',
            alt: 'Handlebars'
            },
            { source: 'https://img.shields.io/badge/MySQL-4479A1.svg?style=for-the-badge&logo=MySQL&logoColor=white',
            alt: 'MySQL'
            },
            { source: 'https://img.shields.io/badge/Heroku-430098.svg?style=for-the-badge&logo=Heroku&logoColor=white',
            alt: 'Heroku'
            },
            { source: 'https://img.shields.io/badge/Sequelize-52B0E7.svg?style=for-the-badge&logo=Sequelize&logoColor=white',
            alt: 'Sequelize'
            },
            { source: 'https://img.shields.io/badge/Socket.io-010101.svg?style=for-the-badge&logo=socketdotio&logoColor=white',
            alt: 'Express'
            },
            { source: 'https://img.shields.io/badge/.ENV-ECD53F.svg?style=for-the-badge&logo=dotenv&logoColor=black',
            alt: 'dotenv'
            }
        ],
        responsibilities: ['Implemented sockets using the Node.js package Socket.io', 'Designed the web page aesthetic and branding for the game', 'Developed back-end RESTful API routes', 'Architected database models utilizing MySQL and Sequelize', 'Troubleshooted and debugged with team members across front-end and back-end code']
    },
    {
        title: 'Dungeons & Dragons: Quest for Glory!',
        media: DnD,
        mobileMedia: DndMobile,
        github: 'https://github.com/BantaChristopher/DnD-quest-for-glory',
        deployed: 'https://bantachristopher.github.io/DnD-quest-for-glory/',
        summary: 'A front-end application that utilizes server-side APIs to randomize a creative D&D character and then generate a quest for that character with ChatGPT’s generative artificial intelligence.',
        responsibilities: ['Implemented the server-side APIs', 'Developed the interactive components through JavaScript', 'Troubleshooted and debugged with team members'],
        technology: [
            { source: 'https://img.shields.io/badge/JavaScript-F7DF1E.svg?style=for-the-badge&logo=JavaScript&logoColor=black',
            alt: 'JavaScript'
            },
            { source: 'https://img.shields.io/badge/HTML5-E34F26.svg?style=for-the-badge&logo=HTML5&logoColor=white',
            alt: 'HTML'
            },
            { source: 'https://img.shields.io/badge/Bulma-00D1B2.svg?style=for-the-badge&logo=Bulma&logoColor=white',
            alt: 'Bulma CSS Framework'
            },
            { source: 'https://img.shields.io/badge/jQuery-0769AD.svg?style=for-the-badge&logo=jQuery&logoColor=white',
            alt: 'JQuery'
            },
            { source: 'https://img.shields.io/badge/REST%20APIs-010101.svg?style=for-the-badge',
            alt: 'RESTful APIs'
            },
            { source: 'https://img.shields.io/badge/chatGPT-74aa9c?style=for-the-badge&logo=openai&logoColor=white',
            alt: 'ChatGPT API'
            },

        ]
    }
];